import React, { useEffect, useState } from "react";
import Counter from "../../components/AdminCards/Counter";
import axios from "axios";
import { apiKey } from "../../config/config";
import MessageCard from "../../components/AdminCards/MessageCard";
import Select from "react-select";
import { languageHelper } from "../../config/helperFunctions";

const Home = () => {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  
  const [counterData, setCounterData] = useState([]);
  const [error, setError] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(user?.user.outlet_id);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/sales-summary`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet,
        },
      })
      .then((res) => {
        setError(false);
        setCounterData([
          {
            path: (
              <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
            ),
            count: Math.round(res.data.total_sales),
            title: languageHelper("TOTAL SALES"),
          },
          // {
          //   path: (
          //     <path d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
          //   ),
          //   count: "10000",
          //   title: languageHelper("Total Purchase"),
          // },
          // {
          //   path: (
          //     <path d="M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
          //   ),
          //   count: "0",
          //   title: languageHelper("Total EXPENSE"),
          // },
          // {
          //   path: (
          //     <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
          //   ),
          //   count: "312",
          //   title: languageHelper("TOTAL RETURN"),
          // },
          {
            path: (
              <path d="M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z" />
            ),
            count: Math.round(
              res.data.order_type_sales.filter(
                (order) => order.order_type_id === 1
              )[0]?.count || 0
            ),
            title: languageHelper("TOTAL LOCAL"),
          },
          {
            path: (
              <path d="M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z" />
            ),
            count: Math.round(
              res.data.order_type_sales.filter(
                (order) => order.order_type_id === 3
              )[0]?.count || 0
            ),
            title: languageHelper("TOTAL TAKEAWAY"),
          },

          {
            path: (
              <path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
            ),
            count: Math.round(
              res.data.order_type_sales.filter(
                (order) => order.order_type_id === 2
              )[0]?.count || 0
            ),
            title: languageHelper("TOTAL DELIVERY"),
          },
          {
            path: (
              <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z" />
            ),
            // count: Math.round(
            //   res.data.order_type_sales.filter(
            //     (order) => order.order_type_id === 3
            //   )[0]?.count ||
            //     0 +
            //       res.data.order_type_sales.filter(
            //         (order) => order.order_type_id === 2
            //       )[0]?.count ||
            //     0 +
            //       res.data.order_type_sales.filter(
            //         (order) => order.order_type_id === 1
            //       )[0]?.count ||
            //     0
            // ),
            count: () => {
              let total = 0;
              res.data.order_type_sales.forEach((order) => {
                total += order.count || 0;
              });
              return Math.round(total);
            },
            title: languageHelper("TOTAL ORDER"),
          },
        ]);
      })
      .catch((err) => {
        setError(err.response.data.message || "Couldn't load data.");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [selectedOutlet, user?.token]);

  useEffect(() => {
    if (user?.user.role === "super-admin") {
      axios
        .get(`${apiKey}/api/rms/admin/get-outlets`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          const mappedOutlets = res.data.map((outlet) => ({
            value: outlet.id,
            label: outlet.name,
          }));
          setOutlets(mappedOutlets);
        })
        .catch((err) => {
          setError(err.response?.data?.message);
        });
    }
  }, [selectedOutlet, user?.token, user?.user.role]);

  if (pageLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        {user?.user.role === "super-admin" && (
          <div className="flex justify-end mb-6">
            <Select
              className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline min-w-64"
              options={outlets}
              onChange={(e) => setSelectedOutlet(e.value)}
              placeholder="Select Outlet"
            />
          </div>
        )}
        <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3 place-items-center">
          {counterData &&
            counterData.map((data, index) => (
              <div
                key={index}
                className="p-3 size-60 border-solid border-8 border-d-bg border-b-transparent rounded-full"
              >
                <div className="size-48 bg-white shadow-lg border rounded-full text-center p-8 mx-auto">
                  <div className="px-8 pb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      width={60}
                      height={40}
                      className="fill-d-bg-text"
                    >
                      {data.path}
                    </svg>
                  </div>
                  <Counter
                    initialValue={data.count}
                    duration={4000}
                    className="text-d-bg-text"
                  />
                  <h1 className="text-d-bg-text font-semibold text-sm">
                    {data.title}
                  </h1>
                </div>
              </div>
            ))}
        </div>
      </div>
    </main>
  );
};

export default Home;
